import { createTypes } from 'redux-recompose';

// ACTIONS RELATIVE ALLA LOGIN
export const actions = createTypes(['AUTHORIZATION_REQUEST', 'AUTHORIZATION_SAML_REQUEST', 'AUTHORIZATION_SUCCESS','AUTHORIZATION_ERROR', 'LOGOUT_SAML_REQUEST'], '@@PML');


const actionCreators = {
    AUTHORIZATION_SAML_REQUEST: () => ({ type: actions.AUTHORIZATION_SAML_REQUEST}),
    LOGOUT_SAML_REQUEST: () => ({ type: actions.LOGOUT_SAML_REQUEST}),
    AUTHORIZATION_REQUEST: () => ({ type: actions.AUTHORIZATION_REQUEST}),
    AUTHORIZATION_SUCCESS: () => ({ type: actions.AUTHORIZATION_SUCCESS}),
    AUTHORIZATION_ERROR: () => ({ type: actions.AUTHORIZATION_ERROR}),
  };
  
export default actionCreators;
